import React, { useEffect } from 'react'
import GoogleAnalytics from 'react-ga'
import { Location } from '@reach/router'

import { stripLocalePrefix } from '../helpers/locale'

function TrackPageViews({ page }) {
  useEffect(() => {
    GoogleAnalytics.pageview(page)
  }, [page])
  return null
}

export default function SubscribedTrackPageViews(props) {
  return (
    <Location>
      {({ location }) => (
        // Track the same page path for both languages, so page stats stay
        // comparable across the /en prefix
        <TrackPageViews
          page={stripLocalePrefix(location.pathname) + location.search}
          {...props}
        />
      )}
    </Location>
  )
}
